export default "__VITE_ASSET__DhE6Thj$__"